import react from "react";
import "./ITCBox.css";
import { useLocation } from "react-router-dom";

export default function IRTCBox({ Head, Title, TitleWidth, TitleWidthMob, Para, ParaS, ParaWidth, ImgSrc, ImgAlt, ImgOrder }) {
  const location = useLocation();
  const isArabic = location.pathname.endsWith("/ar");
  const isMobile = window.innerWidth <= 768;

  return (
    <>
      <div className="ILTCBox">
        <div className="ILTCBoxImg" style={{ order: isMobile ? ImgOrder : "" }}>
          <img src={ImgSrc} alt={ImgAlt} />
        </div>
        <div className={`ILTCBoxText TFut24PxPC ${isArabic ? "arabic" : "english"}`}>
          {/* <div className={`ILTCBHead TFut24PxPC ${isArabic ? "arabic" : "english"}`}>{Head}</div> */}
          <div className={`ILTCBTitle TGLo48PxPC ${isArabic ? "arabic" : "english"}`} style={{ width: isMobile ? TitleWidthMob : TitleWidth }}>
            {Title}
          </div>
          <div className={`ILTCBPara TFut20PxPC ${isArabic ? "arabic" : "english"}`} style={{ width: ParaWidth }} dir={isArabic ? "rtl" : ""}>
            {Para}
          </div>
          <div className={`ILTCBPara TFut20PxPC ${isArabic ? "arabic" : "english"}`} style={{ width: ParaWidth }}>
            {ParaS}
          </div>
        </div>
      </div>
    </>
  );
}
